const options = {
  api_key: process.env.REACT_APP_MOVIEDB_API_KEY,
  language: 'en-US',
}

export default options
